//服务商接口
/* eslint-disable */
import { date } from "jszip/lib/defaults.js";
import axios, { testR, $asyncPost, $asyncGet } from "./common.js";
/* eslint-enable */

import { Message } from "element-ui";
// axios.defaults.baseURL = "https://test-api.hakspay.cn/";
axios.defaults.headers.post["Content-Type"] = "application/json";

/* var _data = {
  //TODO: 需要改成store的token
  //store.state.token.access_token
  access_token: localStorage.getItem("access_token"),
  token_type: localStorage.getItem("token_type"),
  service_no: localStorage.getItem("service_no")
}; */

//请求拦截器
/* axios.interceptors.request.use(async function(res) {
  try {
    // console.log("token-----------------",localStorage.getItem("access_token"));
    //TODO: 加请求头
    return res;
    //接口需要令牌的情况
  } catch (e) {
    console.log("出错", e);
    return res;
  }
}); */

/** 获取所有权限
 * v3/serviceProvider/permission/baseinfo/list
 * service_no @param {string} 服务商号
 */
export const getPermissList = async function () {
  return new Promise((resolve, reject) => {
    axios
      .post(`v3/serviceProvider/permission/baseinfo/list`, {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no")
      })
      .then(res => {
        if (testR(res)) {
          if (res.data.resp_data) {
            var t2 = [];
            var t4 = [];
            var t6 = [];
            // this.all_permission = res.data.resp_data;
            res.data.resp_data.forEach((item, index, arr) => {
              if (item.view_no.trim().length === 2) {
                t2.push({
                  id: item.permission_no.trim(),
                  label: item.permission_name,
                  view_no: item.view_no,
                  childList: []
                });
              } else if (item.view_no.trim().length === 4) {
                t4.push({
                  id: item.permission_no.trim(),
                  label: item.permission_name,
                  view_no: item.view_no,
                  childList: []
                });
              } else if (item.view_no.trim().length === 6) {
                t6.push({
                  id: item.permission_no.trim(),
                  view_no: item.view_no,
                  label: item.permission_name
                });
              }
            });
            // console.log(t2,t4,t6)

            for (let j = 0; j < t4.length; j++) {
              for (let i = 0; i < t6.length; i++) {
                if (t6[i].view_no.slice(0, 4) === t4[j].view_no.trim()) {
                  t4[j].childList.push(t6[i]);
                }
              }
            }
            for (let j = 0; j < t2.length; j++) {
              for (let i = 0; i < t4.length; i++) {
                if (t4[i].view_no.slice(0, 2) === t2[j].view_no.trim()) {
                  t2[j].childList.push(t4[i]);
                }
              }
            }
            // console.log(t2,t6)
            resolve({ t2, t6 });
          }
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**枚举用户组
 * v3/serviceProvider/Usergroup/list
 * @returns
 * //TODO:停用
 */
/* export const getUsergroupList = function () {
  return new Promise((resolve, reject) => {
    axios
      .post("v3/serviceProvider/Usergroup/list", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no")
      })
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(err => {
        Message.error(err);
      });
  });
}; */

/**创建用户组
 * /v3/serviceProvider/Usergroup/generate
 * @param {object} data {group_no:组号，group_name:组名}
 * @returns {Promise}
 */
export const createUserGroup = function (data) {
  return axios
    .post("v3/serviceProvider/Usergroup/generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no: data.group_no,
      group_name: data.group_name
    })
    .catch(e => {
      Message.error(e);
    });
};

/**修改用户组
 * /v3/serviceProvider/Usergroup/Modify
 * @param {object} data
 * @returns {Promise}
 */
export const modifyUserGroup = function (data) {
  return axios
    .post("v3/serviceProvider/Usergroup/Modify", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no: data.group_no,
      group_name: data.group_name,
      flag: data.flag
    })
    .catch(e => {
      Message.error(e);
    });
};

//给用户组授权
//https://test-api.hakspay.cn/v2/ePlatform/Service/ServiceProvider/UserGroupPermission/set

/**
 * 给用户组授权
 * v3/serviceProvider/UserGroupPermission/set
 * @param {object}
 * @returns
 */
export const setUserGroupPermission = function ({
  group_no,
  permission_no,
  description
}) {
  return axios
    .post("v3/serviceProvider/UserGroupPermission/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no,
      permission_no,
      description
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组授权
 * v3/serviceProvider/UserGroupPermission/delete
 * @param {*} param0
 * @returns
 */
export const deleteUserGroupPermission = function ({ group_no, permission_no }) {
  return axios
    .post("v3/serviceProvider/UserGroupPermission/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no,
      permission_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**获取用户组权限
 * v3/serviceProvider/UserGroupPermission/list
 * @param {*} group_no
 * @returns
 */
export const getUserGroupPermission = function (group_no) {
  return axios
    .post("v3/serviceProvider/UserGroupPermission/list", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组
 * v3/serviceProvider/Usergroup/delete
 * @param {*} group_no
 * @returns
 */
export const deleteUsrGroup = function (group_no) {
  return axios
    .post("v3/serviceProvider/Usergroup/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**给用户授权
 * v3/serviceProvider/permission/account/set
 * @param {*} account_id
 * @param {*} permission_no
 * @param {string} account_type mobile_no account_id
 * @returns
 */
export const setAccountPermission = function (
  account_id,
  permission_no,
  account_type
) {
  return axios
    .post("v3/serviceProvider/permission/account/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      account_id,
      account_type,
      permission_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**
 * 删除用户授权
 * v3/serviceProvider/permission/account/delete
 * @param {*} account_id
 * @param {*} permission_no
 * @returns
 */
export const delAccountPermission = function (account_id, permission_no) {
  return axios
    .post("v3/serviceProvider/permission/account/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      account_id,
      permission_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**服务商获取所有受过权的用户
 * v3/serviceProvider/permission/account/ListAccount
 * @returns
 */
export const baseinfoListAccount = function () {
  return new Promise((resolve, reject) => {
    axios
      .post("v3/serviceProvider/permission/account/ListAccount", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no")
      })
      .then(res => {
        if (testR(res)) {
          let list = [];
          for (let i = 0; i < res.data.resp_data.length; i++) {
            list.push(res.data.resp_data[i]);
          }
          resolve(list);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

//TODO：
/** 查询指定用户的权限
 * v3/serviceProvider/permission/account/query
 * @param {*} account_id
 * @returns
 */
export const getAccountPermission = function (account_id) {
  return new Promise((resolve, reject) => {
    axios
      .post("v3/serviceProvider/permission/account/query", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no"),
        account_id
      })
      .then(res => {
        if (testR(res)) {
          /* let list = [];
          for (let i = 0; i < res.data.resp_data.length; i++) {
            list.push(res.data.resp_data[i].permission_no);
          } */
          resolve(res);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**
 * 已废弃
 * 上传图片
 * serviceprovider/v2/common/UploadImg
 * @param {*} img
 * @returns
 */
/* export const serviceUploadImg = function (img) {
  return axios
    .post("serviceprovider/v2/common/UploadImg", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      img
    })
    .catch(e => {
      Message.error(e);
    });
}; */

/**创建店铺
 * v3/serviceProvider/Merchant/Generate
 * @param {*} MerchantInfo
 * @returns
 */
export const merchantGenerate = function (MerchantInfo) {
  return axios
    .post("v3/ServiceProvider/Merchant/Generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      MerchantInfo
    })
    .catch(e => {
      Message.error(e);
    });
};

/**查询店铺信息
 * v3/ServiceProvider/Merchant/Query
 * @param {*} merchant_id
 * @returns
 */
export const serviceQueryMerchant = function (merchant_id) {
  return $asyncGet(`v3/ServiceProvider/Merchant/Query?merchant_id=${merchant_id}&service_no=${localStorage.getItem("service_no")}`)
    .catch(e => {
      Message.error(e);
    });
};

/**查询所有的门店
 * v3/ServiceProvider/Merchant/list
 * @returns
 */
export const getServiceCreateMerchant = function () {
  return axios.get("v3/ServiceProvider/Merchant/list?service_no=" + localStorage.getItem("service_no"))
    .catch(e => {
      Message.error(e);
    });
};

/**修改店铺状态
 * /v3/serviceProvider/Merchant/SetState
 * @param {*} merchant_id
 * @param {*} state
 * @returns
 */
export const merchantSetState = function (merchant_id, state) {
  return axios
    .post("v3/serviceProvider/Merchant/SetState", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      merchant_id,
      state
    })
    .catch(e => {
      Message.error(e);
    });
};

/**创建子服务商
 * v3/serviceProvider/subServiceProvider/generate
 * @param {*} service
 * @returns
 */
export const serviceGenerate = function (service) {
  return axios
    .post("v3/serviceProvider/subServiceProvider/generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      service
    })
    .catch(e => {
      Message.error(e);
    });
};

/** 所有子服务商
 * v3/serviceProvider/subServiceProvider/list
 * @returns
 */
export const getserviceList = function () {
  return axios
    .post("v3/serviceProvider/subServiceProvider/list", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no")
    })
    .catch(e => {
      Message.error(e);
    });
};

/**获取子服务商详细信息
 * v3/serviceProvider/subServiceProvider/query
 * @param {*} sub_service_no
 * @returns
 */
export const serviceQueryProvider = function (sub_service_no) {
  return axios
    .post("v3/serviceProvider/subServiceProvider/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      sub_service_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**
 * 获取系统日志
 * @param {*} param0
 * @returns
 */
export const serviceLogQuery = function ({ start_time, expire_time }) {
  return axios
    .post("v3/serviceProvider/log/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      start_time,
      expire_time
    })
    .catch(e => {
      Message.error(e);
    });
};

/**
 * v3/serviceProvider/log/delete
 */
export const serviceLogDelete = function (com_no) {
  return axios
    .post("v3/serviceProvider/log/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      com_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**查询服务商自己的信息
 * v3/serviceProvider/query
 * @returns {Promise}
 *
 */
export const serviceProviderQuery = function () {
  return $asyncGet(`v3/ServiceProvider/common/query?service_no=${localStorage.getItem("service_no")}`)
};

//v3/ServiceProvider/common/modify
/**
 * 修改服务商资料
 * @param {object} service 修改的内容（是一个数组）
 * @returns {Promise} 发起请求 返回一个 Promise 类型的值
 */
export const serviceProviderModify = function (service) {
  return $asyncPost(`v3/ServiceProvider/common/modify?service_no=${localStorage.getItem("service_no")}`, {
    ...service
  }).catch(e => {
    Message.error(e);
  });
};

/**
 * 重置密码
 * v3/ServiceProvider/common/RestPassword
 */
export const serviceChangePs = function () {
  return $asyncPost("v3/ServiceProvider/common/RestPassword", {});
};

/** 新建系统类别
 *  datas内容
 *  "describe": "string",
 *  "classify_no": "string",
 *  "classify_name": "string",
 *  "parent_classify_no": "string"
 */
export const classifyGenerate = function (datas) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no"),
    ...datas
  };
  return axios
    .post("v3/merchant/chain/classify/generate", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/** 修改系统类别
 *  datas内容
 *  "describe": "string",
 *  "classify_no": "string",
 *  "classify_name": "string",
 *  "parent_classify_no": "string"
 */
export const classifyModify = function (datas) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no"),
    ...datas
  };
  return axios
    .post("v3/merchant/chain/classify/modify", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**
 * /v3/merchant/chain/classify/delete
 * 提供类别编号删除系统类
 * @param {string} classify_no 类别编号
 */
export const classifyDelete = function (classify_no) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no"),
    classify_no
  };
  return axios
    .post("v3/merchant/chain/classify/delete", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

//v3/serviceProvider/Pay/WxPay/Settings

/**
 * 查询配置
 * @param {*} mch_no
 * @returns
 */
export const serviceWxPayquery = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no")
  };
  return axios
    .post("ServiceProvider/v2/Pay/WxPay/query", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**获取所有在线店铺
 * /v3/merchant/offlinestores/onLineMerchant
 * @returns Promise
 */
export const getOnLineMerchant = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no")
  };
  return new Promise((resolve, reject) => {
    axios
      .post("v3/merchant/offlinestores/onLineMerchant", JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**
 *
 * /ServiceProvider/v2/Merchant/list
 * 获取管理的所有门店状态
 */
export const getOfflinestoresList = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no")
  };
  return new Promise((resolve, reject) => {
    axios
      .post("ServiceProvider/v2/Merchant/list", JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

//修改权限
/**
 * 服务商修改权限
 * @param {*} data 修改的权限对象
 * @returns
 */
export const mUpdatePermission = function (data) {
  const param = {
    permission_name: data.permission_name,
    classify_id: data.classify_id,
    description: data.description
  }
  return $asyncPost(`v3/merchant/permission/UpdatePermission/${data.permission_id}`, param);
}

/* v3接口 */
/**
 * 获取所有权限分类
 * @returns
 */
export const getBasePermissionClassify = function () {

}

/* export const getBasePermissionList = function () {

} */

/**
 * 获取所有权限代码
 * @returns Promise{t2,t6} t2 是树形结构数组 t6是所有基本权限
 */
export const getServicePermissList = async function () {
  /* eslint-disable */
  const cls = await $asyncGet("v3/ServiceProvider/permission/Base/ListClassify");
  const permissList = await $asyncGet("v3/ServiceProvider/permission/Base/List");
  if (cls !== false && permissList != false && cls.length > 0) {
    var t2 = [];
    var t4 = [];
    var t6 = [];
    // this.all_permission = res.data.resp_data;
    cls.forEach((item, index, arr) => {
      if (item.parent_classify_id.trim() === "0") {
        t2.push({
          id: item.classify_id.trim(),
          label: item.classify_name,
          view_no: item.view_no ? item.view_no : "",
          parent_classify_id: item.parent_classify_id,
          remark: item.remark,
          childList: []
        });
      }
      if (item.parent_classify_id.trim() !== "0") {
        t4.push({
          id: item.classify_id.trim(),
          label: item.classify_name,
          view_no: item.view_no ? item.view_no : "",
          parent_classify_id: item.parent_classify_id,
          remark: item.remark,
          childList: []
        });
      }
    });
    permissList.forEach((item, index) => {
      t6.push({
        id: item.permission_id.trim(),
        label: item.permission_name,
        view_no: item.view_no ? item.view_no : "",
        classify_id: item.classify_id,
        remark: item.description
      });
    });
    for (let j = 0; j < t4.length; j++) {
      for (let i = 0; i < t6.length; i++) {
        if (t6[i].classify_id === t4[j].id) {
          t4[j].childList.push(t6[i]);
        }
      }
    }
    for (let j = 0; j < t2.length; j++) {
      for (let i = 0; i < t4.length; i++) {
        if (t4[i].parent_classify_id === t2[j].id) {
          t2[j].childList.push(t4[i]);
        }
      }
    }
    return Promise.resolve({ t2, t6 });
  }
}

/* export const */


/**
 * 检索所有角色
 * @param {string} service_no服务商编号 当用户使用时不能为空
 * @returns 
 */
export const getServiceRoleList = function (service_no = localStorage.getItem("service_no") ? localStorage.getItem("service_no") : "") {
  return $asyncGet("v3/ServiceProvider/role/list?service_no=" + service_no);
}

/**
 * 创建服务商的角色
 * @param {{roleNo:string,roleName: string}} roleData {roleNo:角色号,roleName: 角色名称}
 * @returns 
 */
export const serviceCreateRole = function (roleData) {
  const data = {
    ...roleData,
    service_no: localStorage.getItem("service_no")
  }
  return $asyncPost("v3/ServiceProvider/role/create", data)
}

/** 
 *  角色授权 
 * v3/ServiceProvider/role/set
 */
export const roleSetPermission = function (datas) {
  const data = {
    ...datas,
    service_no: localStorage.getItem("service_no")
  }
  return $asyncPost(`v3/ServiceProvider/role/set?role_id=${data.role_id}&service_no=${data.service_no}`, data.permission);
}

/**
 * 获取服务商授权过的所有用户
 * /v3/ServiceProvider/permission/account/ListAccount
 */
export const serviceGetListAccount = function () {
  return $asyncPost("v3/ServiceProvider/permission/account/ListAccount", { service_no: localStorage.getItem("service_no") });
}

/**
 * 获取角色权限
 * @param {string} role_id 角色id
 * /v3/ServiceProvider/role/query
 */
export const roleQuery = function (role_id) {
  return $asyncGet(`v3/ServiceProvider/role/query?role_id=${role_id}&service_no=${localStorage.getItem("service_no")}`)
}


/**
 * 修改角色授权
 * @param {object} data 角色信息 不包含权限
 * v3/ServiceProvider/role/update
 */
export const roleUpdate = function (data) {
  return $asyncPost(`v3/ServiceProvider/role/update?role_id=${data.role_id}&service_no=${localStorage.getItem("service_no")}`, data)
}

/**
 * 删除角色
 * @param {string} role_id 角色id
 * v3/ServiceProvider/role/delete
 */
export const roleDelete = function (role_id) {
  return $asyncPost(`v3/ServiceProvider/role/delete?role_id=${role_id}&service_no=${localStorage.getItem("service_no")}`)
}

/**
 * 设置用户角色
 * @param {string} account_id 用户id
 * @param {string[]} role 角色列表
 * @returns 
 */
export const accountSet = function (account_id, role) {
  return $asyncPost(`v3/ServiceProvider/permission/account/set?account_id=${account_id}&service_no=${localStorage.getItem("service_no")}`, role);
}
/**
 * 服务商查询用户角色
 * @param {string} account_id 用户id
 */
export const accountQuery = function (account_id) {
  return $asyncGet(`v3/ServiceProvider/permission/account/query?account_id=${account_id}&service_no=${localStorage.getItem("service_no")}`);
}
/**
 * 获取所有用户
 */
export const accountSearch = function () {
  return $asyncGet("v3/ServiceProvider/permission/account/search?service_no=" + localStorage.getItem("service_no"));
}
/**
 * 删除用户
 * @param {string} account_id 用户id
 */
export const accountDe = function (account_id) {
  return $asyncPost(`v3/ServiceProvider/permission/account/delete?account_id=${account_id}&service_no=${localStorage.getItem("service_no")}`);
}
/**
 * 获取用户授权的服务商
 */
export const accountList = function () {
  return $asyncGet(`v3/ServiceProvider/permission/account/list?service_no=${localStorage.getItem("service_no")}`);
}




/**
 * 识别营业执照
 * v3/Common/TxtDiscern/DiscernLicense
 * @param {*} img base64格式的图片对象
 * @returns
 */
export const submitDiscernLicense = function (img) {
  return axios.post("v3/Common/TxtDiscern/DiscernLicense", {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    base64: img
  });
};

/**
 * 识别身份证正面
 * v3/Common/TxtDiscern/DiscernFrontID
 * @param {*} img base64格式的图片对象
 * @returns
 */
export const recognitionDiscernFrontID = function (img) {
  return axios.post("v3/Common/TxtDiscern/DiscernFrontID", {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    base64: img
  });
};

/**
 * 识别身份证反面
 * v3/Common/TxtDiscern/DiscernBackID
 * @param {*} img base64格式的图片对象
 * @returns
 */
export const recognitionDiscernBackID = function (img) {
  return axios.post("v3/Common/TxtDiscern/DiscernBackID", {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    base64: img
  });
};

/**
 * 识别银行卡正面
 * v3/Common/TxtDiscern/DiscernBankCard
 * @param {*} img base64格式的图片对象
 * @returns
 */
export const recognitionDiscernBankCard = function (img) {
  return axios.post("v3/Common/TxtDiscern/DiscernBankCard", {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    base64: img
  });
};


/**
 * 创建门店 v3/ServiceProvider/Merchant/Generate
 */
export const generateMerchant = function (data) {
  return $asyncPost(`v3/ServiceProvider/Merchant/Generate?service_no=${localStorage.getItem("service_no")}`, data);
}

/**
 * 商户进件
 * 创建门店 v3/ServiceProvider/Pay/apply
 */
export const merchantPayApply = function (data) {
  return $asyncPost(`v3/ServiceProvider/Pay/apply?service_no=${localStorage.getItem("service_no")}`, data);
}


/**
 * 修改门店进件资料
 * /v3/ServiceProvider/Pay/Update
 */
export const merchantPayUpdate = function (data) {
  return $asyncPost(`v3/ServiceProvider/Pay/Update?service_no=${localStorage.getItem("service_no")}`, data);
}

/**
 * 通过店铺id获取店铺进件资料
 * v3/ServiceProvider/Pay/query
 * @param {string} merchant_id 店铺id
 */
export const merchantPayInfoQuery = function (merchant_id) {
  return $asyncGet(`v3/ServiceProvider/Pay/query?service_no=${localStorage.getItem("service_no")}&merchant_id=${merchant_id}`);
}

/**
 * 通过店铺id 获取到商户是否提交过进件资料
 * @param {string} merchant_id 
 * @returns 
 */
export const merchantPayIsExists = function (merchant_id) {
  return $asyncGet(`v3/ServiceProvider/Pay/isExists?service_no=${localStorage.getItem("service_no")}&merchant_id=${merchant_id}`)
}


/**
 * 上传图片接口
 * common/v2/UploadImg
 * @param {string} img base64
 * @param {string} file_type JPG,GIF,JPEG
 * @returns
 * 获取图片  `${ baseUrl }/media/image/${ res.data.resp_data.media_no }.${ file_type }`
 */
export const serviceUploadImg = function (formData) {
  return axios.post(`v3/ServiceProvider/media/UploadImg?service_no=${localStorage.getItem("service_no")}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
};

/**
 * 下载已上传图片
 * @param {string} media_no 上传图片返回的媒体号
 * @returns 缺少 data:image/png;base64,数据头的base64 的图片文件
 */
export const serviceDownLoadImg = function (media_no) {
  return $asyncPost(`v3/ServiceProvider/media/DownloadImage?media_no=${media_no}&service_no=${localStorage.getItem("service_no")}`)
}

/**
 * 服务商重置店铺密码
 * /v3/ServiceProvider/Merchant/restpassword
 * @param {string} merchant_id 店铺id 
 */
export const resetMchPw = function(merchant_id){
  return $asyncPost(`v3/ServiceProvider/Merchant/restpassword?merchant_id=${merchant_id}&service_no=${localStorage.getItem("service_no")}`)
}